<template>
  <div class="my-3">
    Two blocks, M on the slope and W hanged, are connected by rope crossing through a drum. The slope has an inclination of angle \(\Theta\), the
    coefficient of static friction between M and slope is \(\mu_1\), and that between rope and drum is \(\mu_2\). Try to determine the critical values
    of W which lead to the break of equilibrium under different conditions, and compare with the given solution. Note that two critical values of W
    are involved which cause W move up or move down separately.
  </div>
</template>

<script>
export default {
  name: "Moving_Text"
};
</script>
